var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({attrs:{"color":_vm.alertPrio !== '0' && _vm.associatedIcon
          ? _vm.associatedIcon.color
          : 'background'}},on),[_vm._v("\n      "+_vm._s(_vm.associatedIcon && _vm.associatedIcon.icon)+"\n    ")])]}}])},[_vm._v(" "),_c('span',[_c('div',[_vm._v(_vm._s(_vm.datetime && _vm.datetime.toLocaleDateString()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }